exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#clinic-show-product .modal-dialog{max-width:50%}#clinic-show-product__section-row{border-top:1px solid var(--theme-grey-disabled);padding-top:10px}#clinic-show-product__remove-variant{padding:0 10px;height:37px;border-radius:0;color:var(--theme-color-absent);display:inline-flex;align-items:center;justify-content:center}#clinic-show-product__remove-variant:hover{color:var(--theme-color)}", ""]);

// exports
